// @flow
import Promise from 'bluebird';
import _ from 'lodash';

import api from '../api';
import { stripMarketShare } from '../core/tools/brand';
import ColorBrewer from '../core/tools/colorbrewer';
import environment from '../environment';
import ShapesControl from './ShapesControl';
import infoBoard from '../core/infoboard';

const LayerInfo = (name) => require('../info').get(name);

export class SelectedAreasControl extends ShapesControl {
    constructor() {
        const options = {
            id: 'area-selection',
            name: 'SelectedAreas',
            types: environment.get('CONFIG.FILTERS.AREAS_TYPES'),
            themes: environment.get('CONFIG.FILTERS.AREAS_THEMES'),
            request: api.themes.get.area.sales,
            filter: true,
            overview: true
        };

        super(options);

        (this).colorize = this.colorize.bind(this);
        (this).select = this.select.bind(this);
    }

    static getInstance() {
        if (!SelectedAreasControl._instance) {
            SelectedAreasControl._instance = new SelectedAreasControl();
        }

        return SelectedAreasControl._instance;
    }

    select(value = this.getTypeValue(true), options) {
        if (!options || _.isString(options)) {
            options = {
                remote: {
                    method: 'GET',
                    url: `${environment.get('API_HOST')}/localidade/GetLocation`,
                    params: {
                        locationType: value
                    }
                }
            };
        }

        if (this.getControls().dropdown.data) {
            if (this._checkThemes(['industryRegistration'], null, value)) {
                this.getControls().dropdown.data.input.enable(false);
                this.getControls().dropdown.data.enable = false;
            } else {
                this.getControls().dropdown.data.input.enable(true);
                this.getControls().dropdown.data.enable = true;
            }
        }

        this.getControls().slider.opacity.input.enable(true);
        this.getControls().slider.opacity.enable = true;

        super.select(value, options);
    }

    colorize(featureCollection, layer) {
        return new Promise((resolve, reject) => {
            const id = layer.getMap()._id;

            if (!this.getControls(id).dropdown.data) {
                return resolve(featureCollection);
            }

            super.colorize(featureCollection, layer)
                .then(res => {
                    if (this._checkThemes(['openPoint'])) {
                        _.forEach(res.features, (f) => {
                            if (_.isNumber(f.properties.Total)) {
                                const total = Number(f.properties.RegistryDetail[0].totalIndustry)
                                    .toLocaleString('pt-BR');

                                f.properties.Status = f.properties.Total > 0 ? 'Nominated' : 'Open Point';
                                f.properties.Total = `${f.properties.Status} - ${total}`;
                            }
                        });
                    } else if (this._checkThemes(['socialClass'])) {
                        _.forEach(res.features, f => {
                            if (f.properties.Total === 0) {
                                return f.properties.notPaint = true;
                            }

                            f.properties.notPaint = false;
                        });
                    } else if (this._checkThemes(['locationName'])) {
                        _.forEach(res.features, (f) => {
                            f.properties.Total = f.properties.Nome;
                        });
                    }

                    this.setThemeLayerOptions();

                    if (this._checkThemes(['brandArea', 'segmentLeader'])) {
                        _.forEach(res.features, f => {
                            if (f.properties.Total === 0) {
                                    f.properties.Brand = 0;
                                    return f.properties.notPaint = true;
                            }

                            f.properties.notPaint = false;
                            f.properties.Brand = stripMarketShare(f.properties.Total);
                        });
                    }

                    resolve(res);
                });
        });
    }

    _configureSocialClassSymbology(symbology) {
        const socialClassThemeColors = [
            'rgb(217,95,95)',
            'rgb(224,135,123)',
            'rgb(235,175,155)',
            'rgb(245,211,191)',
            'rgb(255,211,229)',
            'rgb(255,241,227)'
        ];
        symbology.theme = socialClassThemeColors;
        symbology.style.fillOpacity = 0.8;
        symbology.style.weight = 0.5;
        symbology.scale = 'nomenal';

        return symbology;
    }

    setThemeLayerOptions() {
        const options = this.getLayer().options;
        options.value = 'Total';
        if (this._checkThemes(['openPoint', 'locationName', 'socialClass', 'brandArea', 'segmentLeader'])) {
            this.getControls().button.filter.input.enable(false);
            this.getControls().button.filter.enable = false;
            this.getControls().button.overview.input.enable(false);
            this.getControls().button.overview.enable = false;
            this.getControls().slider.range.input.enable(false);
            this.getControls().slider.range.enable = false;

            if (this._checkThemes(['brandArea', 'segmentLeader'])) {
                this.getControls().colorpicker.fillColor.input.enable(false);
                this.getControls().colorpicker.fillColor.enable = false;
                this.getControls().button.overview.input.enable(true);
                this.getControls().button.overview.enable = true;
                options.value = 'Brand';
                options.symbology.scale = 'nomenal';
                options.symbology.theme = this._getAreaThemePalette();
                options.symbology.defaultColor = 'rgb(204,204,204)';
            } else if (this._checkThemes(['openPoint'])) {
                this.getControls().colorpicker.fillColor.input.enable(false);
                this.getControls().colorpicker.fillColor.enable = false;
                options.value = 'Status';
                options.symbology.scale = 'nomenal';
                options.symbology.theme = ColorBrewer.openPoint;
                options.symbology.defaultColor = 'rgb(204,204,204)';
            } else {
                this.getControls().colorpicker.fillColor.input.enable(true);
                this.getControls().colorpicker.fillColor.enable = true;
                this.getControls().colorpicker.fillColor.input.value('Set2:6');
                this.getControls().colorpicker.fillColor.value = 'Set2:6';
                options.symbology.scale = 'nomenal';
                options.symbology.theme = ColorBrewer.Set2['6'];
            }
            options.symbology = this._checkThemes(['socialClass']) ? this._configureSocialClassSymbology(options.symbology) : options.symbology;

            infoBoard.toggleDataboard(false, 0);
        } else {
            this.getControls().colorpicker.fillColor.input.enable(true);
            this.getControls().colorpicker.fillColor.enable = true;
            options.symbology.scale = 'jenks';
            options.symbology.theme = ColorBrewer.OrRd[9];
        }
        this.getLayer().setOptions(options);
    }
}

export default SelectedAreasControl;



// WEBPACK FOOTER //
// ./src/scripts/controls/SelectedAreasControl.js